import { IconWrapper } from '../runtime';
export default IconWrapper('h5', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M11.6219 11.5699C11.9062 11.3086 12.2816 11.1497 12.6932 11.1497C13.5806 11.1497 14.3 11.8884 14.3 12.7997C14.3 13.711 13.5806 14.4497 12.6932 14.4497C12.2027 14.4497 11.7635 14.224 11.4688 13.8683M11.6 11.5856V8.79966C11.6 8.63398 11.7344 8.49966 11.9 8.49966H14.1",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M1.75 1.75363V14.2497M9.25 1.75363V14.2497M1.75 8.00168H9.25",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});